export enum DisasterRecoveryStatusType {
    initiated = "Initiated",
    active = "Active",
    disabled = "Disabled",
    pending = "Pending",
}
